import classes from "./secondaryButton.module.css";
import React, { ButtonHTMLAttributes } from "react";
import { className } from "../../utils/strings";

export type SecondaryButtonProps = {
  variant?: "default" | "active";
} & ButtonHTMLAttributes<HTMLButtonElement>

const SecondaryButton = (props: SecondaryButtonProps) => {
  const {
    variant = "default",
    children,
    ...buttonProps
  } = props;

  const buttonClassName = className({
    [classes.btn]: true,
    [classes[variant]]: true,
    [props.className ?? ""]: true,
  });

  return (
    <button {...{ ...buttonProps, className: buttonClassName }}>
      { children }
    </button>
  );
};

export default SecondaryButton;
